import {
    REDIRECT_AFTER_LOGIN_COOKIE_NAME,
    SHARED_USER_ID_COOKIE_NAME,
    BBG_COM_SITE_REGEX,
    GOOGLE_NEWSSTAND_REGEX
} from "../../../common/constants/Constants";
import generateAppleNewsRegex from "./generateAppleNewsRegex";
import Cookie from "js-cookie";

const Redirect = {

    getRedirectUrlParameter(params: string): null | string {
        const exp = new RegExp("[?&](?:redirectTo|redirect_uri|continueUrl)=([^&$]*)").exec(params);

        return exp ? decodeURIComponent(exp[1]) : null;
    },

    _getRedirectCookieValue(): undefined | string {
        return Cookie.get(REDIRECT_AFTER_LOGIN_COOKIE_NAME);
    },

    _getBConnectCookieValue(): undefined | string {
        return Cookie.get(SHARED_USER_ID_COOKIE_NAME);
    },

    _setRedirectCookie(redirectURL: string): void {
        const isRedirectingToBloomberg = BBG_COM_SITE_REGEX.test(redirectURL);
        const isRedirectingToVendor = this.redirectToVendor(redirectURL);

        if (!isRedirectingToBloomberg && !isRedirectingToVendor) {
            return;
        }

        Cookie.set(REDIRECT_AFTER_LOGIN_COOKIE_NAME, redirectURL);
    },

    _clearRedirectCookie(): void {
        Cookie.remove(REDIRECT_AFTER_LOGIN_COOKIE_NAME);
    },

    redirectTo(redirectURL: string): void {
        location.href = redirectURL;
    },

    hasRedirectCookie(): boolean {
        return !!this._getRedirectCookieValue();
    },

    readRedirectToParamandSetRedirectCookie(params: string): void {
        const redirectUrl = this.getRedirectUrlParameter(params);

        if (redirectUrl) {
            this._setRedirectCookie(redirectUrl);
        }
    },

    handleRedirect(): void {
        const redirectUrl = this._getRedirectCookieValue() as string;
        const bconnectId = this._getBConnectCookieValue() as string;

        this._clearRedirectCookie();

        if (this.redirectForAppleNews(redirectUrl)) {
            this.redirectTo(`${ redirectUrl }?access_token=${ bconnectId }`);

            return;
        }

        if (this.redirectForGoogleNewsstand(redirectUrl)) {
            this.redirectTo(`${ redirectUrl }?token=${ bconnectId }`);

            return;
        }

        this.redirectTo(redirectUrl);
    },

    redirectToVendor(redirectUrl: string): boolean {
        return this.redirectForAppleNews(redirectUrl) || this.redirectForGoogleNewsstand(redirectUrl);
    },

    redirectForGoogleNewsstand(redirectURL: string): boolean {
        return GOOGLE_NEWSSTAND_REGEX.test(redirectURL);
    },

    redirectForAppleNews(redirectURL: string): boolean {
        const APPLE_NEWS_REGEX = generateAppleNewsRegex();
        const redirectToAppleNews = APPLE_NEWS_REGEX.test(redirectURL);

        return redirectToAppleNews;
    }
};

export function onRedirectAllowlist(allowlist: string[] = [], redirectTo?: string): boolean {
    if (!redirectTo) {
        return false;
    }

    return allowlist.includes(redirectTo);
}

export default Redirect;
